export default function getBrowserLocale () {
  const lang = navigator.language || navigator.userLanguage;

  // split language because F.e. russian may bu 'ru' or 'ru-RU' or 'ru-MO' and other combinations
  const langCode = lang.split('-')[0];
  if (langCode === 'ru') {
    return 'ru';
  }
  return 'en';
}
